import { axios } from '@ori/axios';
import type { AxiosInstance } from '@ori/axios';

let customAxiosInstance: AxiosInstance | null;

export const getCustomAxios = (currentLanguage: string) => {
  if (!customAxiosInstance) {
    customAxiosInstance = axios.create({
      baseURL: typeof window === 'undefined' ? '' : window.location.origin,
      headers: {
        'Accept-Language': currentLanguage,
      },
    });
  }

  return customAxiosInstance;
};
